import { Link } from 'react-router-dom';

export default function FooterNav ()
{
	return (
		<ul className='footer-nav'>
			<li>
				<Link to="/mentions-legales" className='footer-nav__link'>
					Mentions légales
				</Link>
			</li>
			{/* <li>
				<Link to="#" className='footer-nav__link'>
					Confidentialité
				</Link>
			</li>
			<li>
				<Link to="#" className='footer-nav__link'>
					Cookies
				</Link>
			</li> */}
			<li>
				<Link to="/honoraires" className='footer-nav__link'>
					Honoraires
				</Link>
			</li>
		</ul>
	);
}
